<template>
    <div class="">
        <el-dialog custom-class="pu-dialog" :show-close="false" :visible.sync="dialogVisible" :width="width"
            :center="center" :append-to-body="appendToBody">
            <template v-slot:title>
                <div class="header-title">
                    <span class="title-text">{{ title }}</span>
                    <el-link type="text" class="title-close" @click="handleClose" icon="el-icon-close" :underline="false"></el-link>
                </div>
            </template>
            <template>
                <div class="dialog-body" :style="{ padding: padding, textAlign: textAlign }">
                    <slot name="content">
                        <span></span>
                    </slot>
                </div>
            </template>
            <template v-slot:footer>
                <div class="aui-flex aui-row-center" :style="footerStyle"  v-if="$slots.footer">
                    <slot name="footer"></slot>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "dgDialog",
    props: {
        appendToBody: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '标题'
        },
        width: {
            type: String,
            default: '480px'
        },
        center: {
            type: Boolean,
            default: true
        },
        padding: {
            type: String,
            default: '20px 25px'
        },
        textAlign: {
            type: String,
            default: 'center'
        },
        footerStyle: {
            type: Object,
            default: () => {
                return {
                    padding: "0 20px 40px"
                }
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
        }
    },
    created() { },
    methods: {
        handleClose() {
            this.dialogVisible = false
            this.$emit('handleClose')
        },
        handleOpen() {
            this.dialogVisible = true
            this.$emit('handleOpen')
        }
    },
}
</script>
<style scoped lang='less'>
/deep/ .pu-dialog {
    background-color: #ffffff;

    .el-dialog__header {
        padding: 30px 20px 10px !important;

        .header-title {
            line-height: 24px;
            font-size: 18px !important;
            color: #303133;
            position: relative;

            .title-close {
                padding: 0 !important;
                line-height: 24px;
                top: 0;
                float: right;
                font-size: 20px;
                color: #303133;
                position: absolute;
                right: 0;
                .el-icon-close{
                    font-size: 24px !important;
                }
            }
        }
    }

    .el-dialog__body {
        padding: 0 !important;
    }

    .el-dialog__footer {
        padding: 0px !important;

        .el-button {
            width: 120px;
        }
    }

}
</style> <style>.flex {
    display: flex
}</style>